<script setup lang="ts">
const { product, close } = useOfferFormDialog()
const { layoutData, loadLayout, tooltips } = useLayout()
await loadLayout()

const { public: config } = useRuntimeConfig()
const filloutId = computed<string>(() => config?.fillout?.offerForm || '')

const iframeKey = useState('offerFormIframeKey', () => 1)

const content = computed(() => tooltips.value.get('offer-form') || null)

const embedCode = computed(() => {
  let script = `<`
  script += `script type="text/javascript" src="https://server.fillout.com/embed/v1/" async></`
  script += `script><div
    class="offer-form__form"
    style="height:500px;"
    data-fillout-id="${filloutId.value}"
    data-fillout-embed-type="standard"
    data-fillout-inherit-parameters
    data-product="${product.value?.name || ''}"
    data-sku="${product.value?.sku || ''}"
    data-fillout-dynamic-resize
    data-iframe-key="${iframeKey.value}"
  ></div>`

  return script
})

const updateKey = () => {
  iframeKey.value = iframeKey.value + 1
}

onUnmounted(() => {
  close()
})
</script>

<template>
  <LazyUiDialog
    name="offer-form-dialog"
    dialog-type="responsive"
    @close="updateKey"
  >
    <template #dialogHeader>
      <span class="dialog__title">
        {{ content?.Title || $t('Request a quote') }}
      </span>
    </template>
    <div v-if="product">
      <div class="offer-form__header">
        <span class="product-item__name">
          {{ product?.mainTitle || product?.name || '' }}
        </span>
        <span class="product-item__brand">
          {{ product?.subTitle }}
        </span>
      </div>
      <div class="offer-form__content">
        <StrapiBlocksText
          v-if="content"
          :nodes="content?.Richtext"
        />

        <div class="offer-form__visual-container">
          <div class="offer-form__image">
            <img
              v-if="product?.image"
              :src="`${product?.image}?f=rs:fit:200:200:0:0`"
              :alt="product?.name"
              width="200"
              height="200"
              loading="lazy"
            >
          </div>
          <ol
            v-if="layoutData?.offerUsps?.[0]?.Usp?.length"
            class="offer-form__features"
          >
            <li
              v-for="usp in layoutData?.offerUsps?.[0]?.Usp || []"
              :key="usp"
              class="offer-form__feature"
            >
              <span class="offer-form__icon"> <NuxtIcon name="icon:check" /></span>
              <span>{{ usp?.Label }}</span>
            </li>
          </ol>
        </div>
      </div>

      <UiEmbed
        v-if="embedCode"
        :key="`iframeKey-${iframeKey}`"
        :embed-code="embedCode"
      />
    </div>
  </LazyUiDialog>
</template>

<style>
@import url('~layers/components/Product/OfferFormDialog.css');
</style>
